import { render } from "./ProductAccordion.vue?vue&type=template&id=f64dce8e"
import script from "./ProductAccordion.vue?vue&type=script&lang=js"
export * from "./ProductAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__